import { AxiosError, AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { ErrorMessage, PaginatedSelfBookingAppointmentTypeList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseSelfBookableAppointmentTypes {
  search?: string;
  ordering?: string;
  limit?: string;
}

function useSelfBookingAppointmentTypes({
  search,
  ordering,
  limit = '20',
}: IUseSelfBookableAppointmentTypes = {}): UseInfiniteQueryResult<
  AxiosResponse<PaginatedSelfBookingAppointmentTypeList>,
  AxiosError<ErrorMessage>
> {
  const queryFn = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedSelfBookingAppointmentTypeList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }
    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
    }

    return client.get(`appointment-self-booking/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['appointment-type-self-booking', search, ordering], queryFn, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useSelfBookingAppointmentTypes;
